export default "__VITE_ASSET__DUUfr4O4__"